module.exports = __webpack_public_path__ + "img/headLogo.ac4b7870.png";